<template>
	<Page :loading="page_loading" noPageMax="1" >
		<div class="centered">
			<Breadcrumb :crumbs="[
					{
						text : 'Home',
						to : {name:'templates'},
					},
					{
						text : 'Organisations',
						to : {name:'orgs'},
					},
				]" />
			<UserPageNav />
			<h1>Organisations you are part of</h1>
			<button class="btn-a" v-on:click="addOrg()" >+ New organisation</button>

			<div class="raised-box s-above" >
				<List
					:loading="loading"
					:results="orgs"
					:columns="[
						{
							label:'Name',
							name:'name',
							rowClick:true,
							text:(v,r)=>r.name||'Personal projects',
							to: (name,org)=>({name:'org',params:{org_id:org.id}}),
						},
						{
							label:'Status',
							name:'subscription',
							text:(v,r)=>{
								var sub = r.subscription;
								return sub.subscribed ? 'Subscription active' : (sub.trial_ends_at? 'Trial ends '+timeToExpiry(sub.trial_ends_at) : 'Trial expired');
							},
						},
					]"
				/>
			</div>

		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page'
	import UserPageNav from '../components/UserPageNav';
	import AddOrg from '../modals/AddOrg';
	import List from '../components/List';
	import Breadcrumb from '../components/Breadcrumb';

	export default {
		components: {UserPageNav,List,Breadcrumb},
		mixins : [Page],
		data(){
			return {
				orgs : [],
				loading : true,
			};
		},

		mounted(){
			var self = this;

			this.$store.dispatch('auth/refreshOrgs').then((orgs)=>{
					self.orgs = orgs;
					self.loading = false;
				})
				;
		},

		methods:{

			addOrg(){
				var modalData = {
					props : {
							orgs : this.orgs
						}
				};
				modalData.component = AddOrg;
				Event.$emit('modal-open', modalData );
			},

			timeToExpiry(mysql_string){
				var d = moment.utc(mysql_string);
				var since = moment.duration(moment().diff(d));
				var hours_since = since.asHours();
				return d.fromNow();
			},

		},
	}

</script>